import {BulkDeleteIncidentsActionButtonWithConfirmation} from "@/pages/statuspages/tabs/incidents/actions/BulkDeleteIncidentsActionButtonWithConfirmation.tsx";

export interface BulkActionsButtonBarProps {
  selectedItemsIds: number[];
  onSuccess: () => void;
}

export const BulkActionsButtonBar = ({selectedItemsIds, onSuccess}: BulkActionsButtonBarProps) => {
  return <BulkDeleteIncidentsActionButtonWithConfirmation selectedItemsIds={selectedItemsIds} onSuccess={onSuccess} />;
};
